export const extractPriceCatalogDummyData = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        document_number: "PC-2026-001",
        buyer_name: "ABC Pvt Ltd",
        vendor_name: "XYZ Traders",
        created_date: new Date().toISOString().split("T")[0],
        line_items: [
          {
            item_name: "Steel Rod",
            item_code: "SR101",
            quantity: 100,
            unit_rate: 500,
            total_price: 50000,
          },
          {
            item_name: "Copper Wire",
            item_code: "CW202",
            quantity: 75,
            unit_rate: 320,
            total_price: 24000,
          },
        ],
      });
    }, 1200);
  });
};

export const extractPriceListDummyData = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        document_number: "PL-2026-010",
        buyer_name: "ABC Pvt Ltd",
        vendor_name: "XYZ Traders",
        created_date: new Date().toISOString().split("T")[0],
        line_items: [
          {
            item_name: "Aluminum Sheet",
            item_code: "AS700",
            quantity: 50,
            unit_rate: 900,
            total_price: 45000,
          },
          {
            item_name: "Industrial Nut",
            item_code: "IN510",
            quantity: 1000,
            unit_rate: 12,
            total_price: 12000,
          },
        ],
      });
    }, 1200);
  });
};
